(function () {
  if (window.__junisCartSync) return;
  window.__junisCartSync = true;

  var CHANGE_URL = (window.Theme && window.Theme.routes && window.Theme.routes.cart_change_url) || '/cart/change.js';
  var CART_URL = '/cart.js';

  var lastSyncedUnits = {}; // line item key → 마지막 서버 전송 units (flush dirty 판정)
  var inflight = [];        // 진행 중 sync Promise
  var currentLineCount = null;  // 현재 상품 종류 수(라인 아이템 수) (배지 source of truth)

  // ---------------- money 텍스트 헬퍼 ----------------
  function parseMinor(text) {
    var m = (text || '').match(/-?[\d.,]+/);
    if (!m) return null;
    var s = m[0];
    var lastDot = s.lastIndexOf('.');
    var precision = lastDot !== -1 && s.length - lastDot - 1 <= 4 ? s.length - lastDot - 1 : 0;
    var digits = s.replace(/\D/g, '');
    if (!digits) return null;
    return { minor: parseInt(digits, 10), precision: precision, match: m[0] };
  }
  function formatMinor(minor, precision) {
    minor = Math.max(0, Math.round(minor));
    if (precision > 0) {
      var div = Math.pow(10, precision);
      var whole = Math.floor(minor / div);
      var frac = (minor % div).toString();
      while (frac.length < precision) frac = '0' + frac;
      return whole.toLocaleString('en-US') + '.' + frac;
    }
    return minor.toLocaleString('en-US');
  }
  function setMoney(el, baselineText, newMinor) {
    var p = parseMinor(baselineText);
    if (!p) return;
    var newText = baselineText.replace(p.match, formatMinor(newMinor, p.precision));
    try { el.setAttribute('value', newText); } catch (e) { /* ignore */ }
    el.textContent = newText;
  }
  function baselineOf(el) { return el.getAttribute('data-junis-baseline') || el.textContent || ''; }
  function baselineMinorOf(el) { var p = parseMinor(baselineOf(el)); return p ? p.minor : 0; }
  function currentMinorOf(el) { var p = parseMinor(el.textContent || ''); return p ? p.minor : 0; }

  // ---------------- DOM 조회 ----------------
  function rowOf(el) { return el && el.closest ? (el.closest('.cart-items__table-row') || el.closest('tr') || el.closest('li')) : null; }
  function lineTotalEl(row) { return row ? row.querySelector('[data-junis-line-total]') : null; }
  function totalEl() { return document.querySelector('[data-junis-cart-total], [data-testid="cart-total-value"]'); }

  // ---------------- 라인(상품 종류) 수 계산 ----------------
  // 배지 = 카트 라인 아이템(상품 종류) 개수. data-cart-line 으로 중복 제거
  //   (헤더 드로워 + 카트 페이지가 동일 라인을 동시 렌더할 수 있음) · FOC 라인(per-carton 속성 없음)도 포함.
  function lineCountFromDom() {
    var present = {};
    var removing = {};
    document.querySelectorAll('.junis-cart-qty-input[data-cart-line]').forEach(function (inp) {
      var k = inp.getAttribute('data-cart-line');
      if (k == null) return;
      var r = rowOf(inp);
      if (r && r.classList.contains('removing')) removing[k] = true;
      else present[k] = true;
    });
    var n = 0;
    Object.keys(present).forEach(function (k) { if (!removing[k]) n++; });
    return n;
  }
  // 라인(상품 종류) 수 = 서버 cart.items 길이 (FOC 포함 · 권위값).
  function lineCountFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return cart.items.length;
  }

  // ---------------- 배지 (상품 종류 수 = 라인 아이템 수) ----------------
  // cart-icon.renderCartBubble 은 인스턴스 arrow field → 인스턴스에 override.
  // Horizon 이 units 로 호출해도 항상 currentLineCount(라인 수)를 그림 → units 깜빡임 제거.
  function patchCartIcon() {
    var icon = document.querySelector('cart-icon');
    if (!icon || icon.__junisPatched || typeof icon.renderCartBubble !== 'function') return icon || null;
    icon.__junisPatched = true;
    var orig = icon.renderCartBubble.bind(icon);
    icon.renderCartBubble = function (count, fromForm, animate) {
      // 항상 currentLineCount 를 절대값으로 세팅 (fromForm=false). Horizon 의 product-form 가산 경로(누적) 차단 + units 차단.
      return orig(currentLineCount != null ? currentLineCount : count, false, animate);
    };
    return icon;
  }
  function setBubbleCount(count) {
    currentLineCount = count;
    var icon = patchCartIcon();
    if (icon && typeof icon.renderCartBubble === 'function') {
      try { icon.renderCartBubble(count, false, false); } catch (e) { /* ignore */ } // has-cart 클래스 + sessionStorage 처리
    }
    // cart-icon 밖의 cart-bubble(드로워 'Cart' 타이틀 등) = 수동 갱신.
    document.querySelectorAll('[ref="cartBubbleCount"]').forEach(function (el) {
      if (icon && icon.contains && icon.contains(el)) return;
      var bubble = el.closest('.cart-bubble');
      el.textContent = String(count);
      el.classList.toggle('hidden', count === 0);
      if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
    });
  }
  function markInCartCards(cart) {
    var cards = document.querySelectorAll('product-card[data-product-id]');
    if (!cards.length) return;
    var inCart = {};
    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function (it) {
        if (it && it.product_id != null) inCart[String(it.product_id)] = true;
      });
    }
    cards.forEach(function (card) {
      card.classList.toggle('junis-in-cart', !!inCart[card.getAttribute('data-product-id')]);
    });
  }

  function refreshBubbleFromServer() {
    fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var b = lineCountFromCart(cart);
        if (b != null) setBubbleCount(b);
        markInCartCards(cart);
      })
      .catch(function () {});
  }

  function renderEmptyCart() {
    var ci = document.querySelector('cart-items-component[data-drawer]') || document.querySelector('cart-items-component');
    var tpl = document.getElementById('empty-cart-template');
    if (ci && tpl && tpl.content) ci.replaceChildren(document.importNode(tpl.content, true));
    var dialog = document.querySelector('.cart-drawer__dialog');
    if (dialog) dialog.classList.add('cart-drawer--empty');
    setBubbleCount(0);
  }

  // ---------------- 낙관적 갱신 ----------------
  function scaleLine(row, boxes) {
    var inp = row.querySelector('.junis-cart-qty-input[data-junis-per-carton]');
    var per = inp ? parseInt(inp.getAttribute('data-junis-per-carton'), 10) || 0 : 0;
    // per>0(일반)=입력값이 box 수 → units=boxes×per · per=0(FOC)=입력값이 곧 units.
    var units = per > 0 ? boxes * per : boxes;
    var lt = lineTotalEl(row);
    if (lt) {
      var initBoxes = parseInt(lt.getAttribute('data-junis-init-boxes'), 10);
      if (per > 0 && initBoxes > 0) {
        setMoney(lt, baselineOf(lt), baselineMinorOf(lt) * boxes / initBoxes);
      } else if (per <= 0) {
        // FOC: 입력값(boxes 파라미터)=units → units 비율로 라인 합계 스케일 (init-boxes=0 이라 위 분기 미동작)
        var initUnits = parseInt(lt.getAttribute('data-junis-init-units'), 10);
        if (initUnits > 0) setMoney(lt, baselineOf(lt), baselineMinorOf(lt) * boxes / initUnits);
      }
    }
    // 드로워 carton-info ("N boxes = N units")
    var info = row.querySelector('.junis-cart-carton-info[data-junis-carton-info]');
    if (info) {
      var boxLabel = info.querySelector('[data-junis-box-label]');
      var unitsLabel = info.querySelector('[data-junis-units-label]');
      if (boxLabel) boxLabel.textContent = boxes + ' box' + (boxes > 1 ? 'es' : '');
      if (unitsLabel && per > 0) unitsLabel.textContent = units.toLocaleString('en-US') + ' units';
    }
    var boxCell = row.querySelector('[data-junis-box-cell]');
    if (boxCell && per > 0) boxCell.textContent = boxes;
    var unitCell = row.querySelector('[data-junis-unit-cell]');
    if (unitCell) unitCell.textContent = units.toLocaleString('en-US');
  }
  // Total units 노드(서버 cart.item_count)를 재계산 없이 천단위 콤마로만 포맷.
  //   카트 드로워는 Horizon cart-drawer 가 cart:update 시 renderSection 으로 콤마 없는 값을 렌더 →
  //   라인 input 기반 재계산이 불가하므로 노드 텍스트를 직접 포맷. (이미 콤마면 skip → 무한루프 없음)
  function formatSummaryUnits() {
    document.querySelectorAll('[data-junis-sum-units]').forEach(function (el) {
      var raw = String(el.textContent).trim();
      if (!raw) return;
      var n = parseInt(raw.replace(/[^0-9]/g, ''), 10);
      if (isNaN(n)) return;
      var formatted = n.toLocaleString('en-US');
      if (formatted !== raw) el.textContent = formatted;
    });
  }
  function recomputeSummaryCounts() {
    var itemsEls = document.querySelectorAll('[data-junis-sum-items]');
    var unitsEls = document.querySelectorAll('[data-junis-sum-units]');
    if (!itemsEls.length && !unitsEls.length) return;
    var lines = document.querySelectorAll('.junis-cart-qty-input[data-junis-per-carton]');
    if (!lines.length) { formatSummaryUnits(); return; }
    var items = 0;
    var units = 0;
    lines.forEach(function (inp) {
      var r = rowOf(inp);
      if (r && r.classList.contains('removing')) return;
      items++;
      var per = parseInt(inp.getAttribute('data-junis-per-carton'), 10) || 0;
      var bx = parseInt(inp.value, 10) || 0;
      units += per > 0 ? bx * per : bx;
    });
    itemsEls.forEach(function (el) { el.textContent = String(items); });
    unitsEls.forEach(function (el) { el.textContent = units.toLocaleString('en-US'); });
  }
  function recomputeTotal() {
    recomputeSummaryCounts();
    var normalSum = 0, focSum = 0;
    document.querySelectorAll('[data-junis-line-total]').forEach(function (lt) {
      var r = rowOf(lt);
      if (r && r.classList.contains('removing')) return;
      var amt = currentMinorOf(lt);
      if (lt.getAttribute('data-junis-line-type') === 'FOC') focSum += amt;
      else normalSum += amt;
    });
    // 카트 페이지 footer(페이지 전용 노드): Subtotal(excl FOC)·Total = normal, FOC lines = foc.
    document.querySelectorAll('[data-junis-pg-sub], [data-junis-pg-total]').forEach(function (el) {
      setMoney(el, baselineOf(el), normalSum);
    });
    document.querySelectorAll('[data-junis-pg-foc]').forEach(function (el) {
      setMoney(el, baselineOf(el), focSum);
    });
    var t = totalEl();
    if (t) setMoney(t, baselineOf(t), normalSum + focSum);
  }
  function optimisticFromInput(input) {
    var boxes = parseInt(input.value, 10);
    if (!boxes || boxes <= 0) return;
    var row = rowOf(input);
    if (row) scaleLine(row, boxes);
    recomputeTotal();
    setBubbleCount(lineCountFromDom());
  }

  // ---------------- 서버 권위 reconcile ----------------
  function reconcile(cart) {
    if (!cart) { recomputeTotal(); return; }
    markInCartCards(cart);
    // 빈 카트 = 즉시 client 렌더 (서버 재렌더 대기 없음).
    if (cart.item_count === 0 || (Array.isArray(cart.items) && cart.items.length === 0)) {
      renderEmptyCart();
      return;
    }
    // 라인 가격을 권위 final_line_price 로 보정 (baseline-raw 비율 → 통화 포맷 보존 · volume tier 포함).
    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        var input = document.querySelector('.junis-cart-qty-input[data-variant-id="' + item.variant_id + '"]');
        var lt = lineTotalEl(rowOf(input));
        if (lt) {
          var lBaseRaw = parseInt(lt.getAttribute('data-junis-baseline-raw'), 10);
          if (lBaseRaw > 0 && typeof item.final_line_price === 'number') {
            setMoney(lt, baselineOf(lt), baselineMinorOf(lt) * (item.final_line_price / lBaseRaw));
          }
        }
      });
    }
    recomputeTotal();                       // estimated total = Σ 라인 (B2B: total=subtotal)
    setBubbleCount(lineCountFromDom());  // 배지 = 상품 종류 수(라인 수)
  }

  // ---------------- 클라이언트 오류 비컨 ----------------
  // /cart/change.js(Shopify 코어)는 서버 로그가 없고 실패는 클라에서만 관측 가능 → 실패 시에만
  // App Proxy /client-log 로 1발 보고(CloudWatch `[client-log]`). 진단 채널 실패는 본流에 무영향.
  window.junisClientLog = function (event, detail) {
    try {
      var payload = JSON.stringify({ event: event, detail: detail || {} });
      if (navigator.sendBeacon && navigator.sendBeacon('/apps/wishtrade/client-log', new Blob([payload], { type: 'text/plain' }))) return;
      fetch('/apps/wishtrade/client-log', { method: 'POST', body: payload, keepalive: true }).catch(function () {});
    } catch (e) { /* ignore */ }
  };

  // ---------------- 서버 sync (sections 없음 = fast · line item key 기준) ----------------
  function syncLine(key, units) {
    if (!key) return Promise.resolve();
    var p = (window.junisFetch || fetch)(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: units }),
      junisTimeout: 6000,
      junisRetries: 1,
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('cart change ' + r.status)); })
      .then(function (cart) { lastSyncedUnits[key] = units; reconcile(cart); return cart; })
      .catch(function (err) {
        window.junisClientLog('cart_sync_fail', {
          err: String((err && (err.name + ':' + err.message)) || err).slice(0, 160),
          units: units,
        });
      })
      .finally(function () { var i = inflight.indexOf(p); if (i !== -1) inflight.splice(i, 1); });
    inflight.push(p);
    return p;
  }
  function unitsFromInput(input) {
    var per = parseInt(input.getAttribute('data-junis-per-carton'), 10) || 0;
    var boxes = parseInt(input.value, 10) || 0;
    return per > 0 ? boxes * per : boxes;
  }

  function inputForLine(line) {
    return document.querySelector('.junis-cart-qty-input[data-cart-line="' + line + '"]')
      || document.querySelector('input[data-cart-line="' + line + '"]');
  }
  function patchUpdateQuantity() {
    var C = window.customElements && window.customElements.get('cart-items-component');
    if (!C || C.prototype.__junisPatched) return;
    C.prototype.__junisPatched = true;

    C.prototype.updateQuantity = function (config) {
      var input = inputForLine(config.line);
      var row = rowOf(input);
      var key = row ? row.getAttribute('data-key') : null;
      var per = input ? parseInt(input.getAttribute('data-junis-per-carton'), 10) || 0 : 0;
      var units = config.quantity === 0 ? 0 : per > 0 ? config.quantity * per : config.quantity;
      if (key) syncLine(key, units);
    };

    C.prototype.onLineItemRemove = function (line) {
      var input = inputForLine(line);
      var row = rowOf(input);
      var key = row ? row.getAttribute('data-key') : null;
      if (!key) return;
      // 삭제 더블클릭 재진입 가드 — 이미 removing(삭제 진행 중) 행이면 syncLine(key,0) 중복 발사 차단.
      if (row && row.classList.contains('removing')) return;
      syncLine(key, 0);
      if (row) row.classList.add('removing'); // recompute 에서 제외 + CSS fade 트리거
      var remaining = 0;
      document.querySelectorAll('.cart-items__table-row[data-key]').forEach(function (r) {
        if (!r.classList.contains('removing')) remaining++;
      });
      if (remaining === 0) { renderEmptyCart(); return; } // 빈 카트 = 즉시 (view transition 없음)
      recomputeTotal();
      setBubbleCount(lineCountFromDom());
      if (!row) return;
      var removeRow = function () { if (row.parentNode) row.remove(); };
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { removeRow(); return; }
      row.style.setProperty('--row-height', row.clientHeight + 'px');
      var done = false, once = function () { if (done) return; done = true; removeRow(); };
      row.addEventListener('animationend', once, { once: true });
      setTimeout(once, 600); // 애니메이션 미발동 fallback
    };
  }
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('cart-items-component').then(patchUpdateQuantity);
    window.customElements.whenDefined('cart-icon').then(patchCartIcon);
  }
  patchUpdateQuantity();
  patchCartIcon();

  recomputeSummaryCounts();
  var junisDrawerEl = document.querySelector('cart-drawer-component');
  if (junisDrawerEl && window.MutationObserver) {
    new MutationObserver(formatSummaryUnits).observe(junisDrawerEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // ---------------- 즉시 낙관적 (Horizon 300ms debounce 전에 반영) ----------------
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('junis-cart-qty-input')) optimisticFromInput(t);
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.junis-cart-qty-btn') : null;
    if (!btn) return;
    var wrap = btn.closest('cart-quantity-selector-component');
    var input = wrap ? wrap.querySelector('.junis-cart-qty-input') : null;
    if (input) setTimeout(function () { optimisticFromInput(input); }, 0);
  }, true);

  // add-to-cart 등 Horizon cart:update 경로 → /cart.js 권위 조회 후 배지 박스 수 보정.
  // (CartAddEvent.resource 는 추가된 단일 라인이라 items 가 없음 → 직접 fetch.)
  // (+/- 는 cart:update 를 안 쓰고 reconcile 로 직접 갱신 → 이 리스너 무관.)
  document.addEventListener('cart:update', function () { refreshBubbleFromServer(); });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-junis-order-cta]').forEach(function (btn) {
      btn.__junisBusy = false;
      btn.classList.remove('junis-cta-loading');
      btn.removeAttribute('aria-busy');
    });
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        seedLastSynced(cart);
        var b = lineCountFromCart(cart);
        if (b != null) setBubbleCount(b); // 배지 즉시 정확 (라인 수)
        var renderedUnits = 0;
        document.querySelectorAll('.junis-cart-qty-input[data-junis-per-carton]').forEach(function (inp) {
          var per = parseInt(inp.getAttribute('data-junis-per-carton'), 10) || 0;
          var bx = parseInt(inp.value, 10) || 0;
          renderedUnits += per > 0 ? bx * per : bx;
        });
        if (cart.item_count === renderedUnits) return; // stale 아님 → 그대로 (bfcache 보존)
        // stale: 잘못된 드로워 노출 차단 — 열려있으면 닫는다.
        var dlg = document.querySelector('dialog.cart-drawer__dialog');
        if (dlg && dlg.open) {
          var drawer = document.querySelector('cart-drawer-component');
          try { drawer && typeof drawer.close === 'function' ? drawer.close() : dlg.close(); } catch (e2) { /* ignore */ }
        }
        if (cart.item_count === 0) renderEmptyCart();
        else document.dispatchEvent(new CustomEvent('discount:update', { bubbles: true, detail: { data: {} } }));
      })
      .catch(function () {});
  });

  // ---------------- flush-on-navigation ----------------
  // 미동기 라인을 현재 input 값으로 강제 sync + in-flight await. "Create B2B Order" 진입 전 호출.
  window.junisCartFlush = function () {
    document.querySelectorAll('.junis-cart-qty-input[data-junis-per-carton]').forEach(function (input) {
      var row = rowOf(input);
      var key = row ? row.getAttribute('data-key') : null;
      if (!key) return;
      var units = unitsFromInput(input);
      if (lastSyncedUnits[key] !== units) syncLine(key, units);
    });
    var all = Promise.all(inflight.slice());
    var cap = new Promise(function (resolve) { setTimeout(resolve, 14000); });
    return Promise.race([all, cap]).then(function () {
      var synced = true;
      var unsyncedCount = 0;
      var lineCount = 0;
      document.querySelectorAll('.junis-cart-qty-input[data-junis-per-carton]').forEach(function (input) {
        var row = rowOf(input);
        var key = row ? row.getAttribute('data-key') : null;
        if (!key) return;
        lineCount++;
        if (lastSyncedUnits[key] !== unitsFromInput(input)) { synced = false; unsyncedCount++; }
      });
      if (!synced) window.junisClientLog('cart_flush_unsynced', { lines: lineCount, unsynced: unsyncedCount });
      return synced;
    });
  };

  window.junisCartSyncWarn = function () {
    var msg =
      (window.junisI18n && window.junisI18n['junis.cart.sync_error']) ||
      'Your latest cart change could not be saved. Please check your connection and try again.';
    var el = document.getElementById('junis-cart-sync-warn');
    if (!el) {
      el = document.createElement('div');
      el.id = 'junis-cart-sync-warn';
      el.setAttribute('role', 'alert');
      el.style.cssText =
        'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:99999;' +
        'background:#1a1a1a;color:#fff;padding:12px 18px;border-radius:4px;font-size:14px;' +
        'line-height:1.4;max-width:90%;text-align:center;box-shadow:0 4px 16px rgba(0,0,0,.25);';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    clearTimeout(el.__junisWarnT);
    el.__junisWarnT = setTimeout(function () { if (el.parentNode) el.remove(); }, 6000);
  };

  // 초기 배지 source 동기화 (override 가 units 대신 라인 수를 그리도록).
  currentLineCount = lineCountFromDom();

  function seedLastSynced(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    cart.items.forEach(function (item) {
      if (item && item.key && !(item.key in lastSyncedUnits)) lastSyncedUnits[item.key] = item.quantity;
    });
  }

  // 초기 카드 in-cart 표시 — 배지 로직과 분리(별도 fetch).
  fetch(CART_URL, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) { markInCartCards(cart); seedLastSynced(cart); })
    .catch(function () {});
})();
